import "./SingleProgramTemplate.module.css"
import Header from "@/reusable_sections/Header"
import Program from "./sections/Program"
import Footer from "@/reusable_sections/Footer"

export default function SingleProgramTemplatePage() {

  return (
    <div>
      <Header />
      <Program />
      <Footer />
    </div>
  )
}
